const infoPopup = document.querySelector('[data-info-popup]');

if (infoPopup) {
    const STORAGE_KEY = 'info-popup-seen';
    const isHomepage = infoPopup.dataset.isHomepage === 'index';
    const popupHash = infoPopup.dataset.popupHash;
    const seenHash = localStorage.getItem(STORAGE_KEY);
    const hasSeenPopup = seenHash === popupHash;

    if (isHomepage || !hasSeenPopup) {
        infoPopup.classList.add('active');

        if (!hasSeenPopup) {
            localStorage.setItem(STORAGE_KEY, popupHash);
        }
    }

    const closeButton = infoPopup.querySelector('[data-close-popup]');
    closeButton.addEventListener('click', (e) => {
        e.preventDefault();
        infoPopup.classList.remove('active');
    });
    infoPopup.addEventListener('click', (e) => {
        if (e.target !== infoPopup) return;
        infoPopup.classList.remove('active');
    });
}